export default "__VITE_ASSET__87d2275b__"